module.exports = __webpack_public_path__ + "static/media/DSC04780.3f3587bf.JPG";